export default function apiUrl(): string {
  const clientUrl = process.env.NEXT_PUBLIC_API_URL as string
  const backendUrl = process.env.NEXT_PUBLIC_SSR_API_URL || clientUrl
  if (typeof window === 'undefined') {
    return backendUrl
  }
  return clientUrl
}
